<div class="d-flex">
  <div
    appThrottleClick
    (throttleClick)="navItemSelected()"
    [ngClass]="{
      active: isNavItemActive$ | async,
      animating: animating$ | async
    }"
    class="nav-item custom-nav-item">
    <div *ngIf="hasIcons$ | async" class="nav-item-icon">
      <img [src]="navItem.iconSrc" alt="icon" i18n-alt class="nav-bar-icon" />
      <img [src]="navItem.iconFilledSrc" alt="icon-filled" i18n-alt class="nav-bar-icon-filled" />
    </div>
    <div class="nav-item-label" [ngClass]="{ 'multi-line-label': multiLineNavItem$ | async }">
      {{ navItem.name }}
    </div>
  </div>
</div>
